import type { AgentAvatar, AvatarFamily, AvatarPalette } from '@algoboo/schema/api'
import { resolvePart, type PartOption } from './catalog.js'

/** The editor offers only parts with an authored attachment on that base. */
export const STUDIO_FINISHES = ['jelly', 'frosted', 'matte'] as const
export const EMBLEM_OPTIONS: PartOption[] = [{ id: 'star', label: 'Star' }, { id: 'lightning-bolt', label: 'Bolt' }]
const AURA_HEADWEAR: PartOption[] = [{ id: 'beanie', label: 'Beanie' }, { id: 'antenna', label: 'Antenna' }]

export function fittedHeadwear(family: AvatarFamily): PartOption[] {
  return family === 'aura' ? AURA_HEADWEAR : []
}

/** Render old designs safely without mutating the stored source design. */
export function fitAvatar(source: AgentAvatar): AgentAvatar {
  const avatar: AgentAvatar = { family: source.family, palette: source.palette,
    expression: source.expression ?? 'smile',
    material: source.material === 'frosted' || source.material === 'matte' ? source.material : 'jelly' }
  const headwear = resolvePart('headwear', source.headwear)
  if (fittedHeadwear(source.family).some((part) => part.id === headwear)) avatar.headwear = headwear!
  const emblem = resolvePart('loadout', source.loadout)
  if (EMBLEM_OPTIONS.some((part) => part.id === emblem)) avatar.loadout = emblem!
  return avatar
}

export function fittedAvatarKey(source: AgentAvatar): string {
  const a = fitAvatar(source)
  return JSON.stringify([a.family, a.palette, a.expression, a.material, a.headwear, a.loadout])
}

/** Fixed display looks keep family pickers stable while the user changes traits. */
export const BASE_PREVIEW_PALETTE: Record<AvatarFamily, AvatarPalette> = {
  glim: 'ivory', aura: 'lilac', mochi: 'peach', lumi: 'plum', nova: 'sky',
  bop: 'mint', nimbus: 'pearl', pico: 'sky', mellow: 'sage', comet: 'peach',
}
